export const ETaskDefinitionTemplateScope = {
  Company: "company",
  Whitelabel: "whitelabel",
} as const;

export type TTaskDefinitionTemplateScope =
  (typeof ETaskDefinitionTemplateScope)[keyof typeof ETaskDefinitionTemplateScope];
